import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-book-seller-statewisestatement',
  templateUrl: './book-seller-statewisestatement.component.html',
  styleUrl: './book-seller-statewisestatement.component.scss'
})
export class BookSellerStatewisestatementComponent {

  book_name: string = '';
  isLoading = false;
  updateStatus = false;

  filteredstatewisesubcount: any[] = [];

  total_sub_count = 0;
  totalparcel = 0;

  dispatchDisplayDate: string = '';

  constructor(
    private dialogref: MatDialogRef<BookSellerStatewisestatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {

    this.updateStatus = this.data?.updateStatus ?? false;

    // ✅ FIXED: Safe dispatch date handling (NO BUG POSSIBLE NOW)
    this.dispatchDisplayDate = this.formatDate(
      this.data?.dispatchdate || this.data?.dispatchDate
    );

    // BOOK NAME SAFE HANDLING
    this.book_name = Array.isArray(this.data?.book_name)
      ? this.data.book_name.join(', ')
      : (this.data?.book_name ?? 'All Books');

    this.getStatewiseStatement();
  }

  // ================= DATE FORMAT =================
  formatDate(dateValue: any): string {

    if (!dateValue) return '-';

    const d = new Date(dateValue);

    if (isNaN(d.getTime())) return '-';

    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // ================= API =================
  getStatewiseStatement(): void {

    this.isLoading = true;

    const request = {
      state: this.data?.state || [],
      district: this.data?.district || [],
      start_date: this.data?.start_date || '',
      end_date: this.data?.end_date || '',
      book_name: this.data?.book_name || [],
      delivery_mode: this.data?.delivery_mode || [],
      sub_distribution_mode: this.data?.sub_distribution_mode || [],
      distribution_mode: this.data?.distribution_mode || []
    };

    this.service.getDistributionRepresentativeSBhetHastewise2(request)
      .subscribe({

        next: (response: any) => {

          this.isLoading = false;

          if (response?.status && Array.isArray(response?.data)) {

            const grouped: any = {};

            response.data.forEach((item: any) => {

              const state = item.state || 'Unknown';

              if (!grouped[state]) {
                grouped[state] = {
                  state,
                  total_booksellers: 0,
                  total_book_copies: 0
                };
              }

              grouped[state].total_booksellers += Number(item.total_booksellers || 0);
              grouped[state].total_book_copies += Number(item.total_book_copies || 0);
            });

            this.filteredstatewisesubcount = Object.values(grouped);

            this.calculateTotals();

          } else {
            this.filteredstatewisesubcount = [];
            this.resetTotals();
          }
        },

        error: () => {
          this.isLoading = false;
        }
      });
  }

  // ================= TOTALS =================
  calculateTotals(): void {

    this.total_sub_count = 0;
    this.totalparcel = 0;

    this.filteredstatewisesubcount.forEach((item: any) => {
      this.total_sub_count += Number(item.total_booksellers || 0);
      this.totalparcel += Number(item.total_book_copies || 0);
    });
  }

  resetTotals(): void {
    this.total_sub_count = 0;
    this.totalparcel = 0;
  }

  // ================= PRINT =================
  printReport(): void {

    const win = window.open('', '_blank', 'width=1000,height=700');
    if (!win) return;

    const html = `
    <html>
    <head>
      <title>Statewise Statement</title>

      <style>
        body { font-family: Arial; margin: 20px; }

        .header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
          position: relative;
        }

        .dispatch {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 13px;
          font-weight: normal;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 13px;
        }

        th { background: #f2f2f2; }

        .total-row {
          font-weight: bold;
          background: #eee;
        }

        @page { size: A4; margin: 10mm; }
      </style>
    </head>

    <body onload="window.print(); window.close();">

      <div class="header">
        विवेक पुस्तक प्रकाशन -
        पुस्तकाचे नाव - ${this.book_name}

        <span class="dispatch">
          वितरण दि. - ${this.dispatchDisplayDate || '-'}
        </span>
      </div>

      <table>
        <thead>
          <tr>
            <th>राज्य</th>
            <th>वर्गणीदार संख्या</th>
            <th>प्रति संख्या</th>
          </tr>
        </thead>

        <tbody>

          ${this.filteredstatewisesubcount.map(item => `
            <tr>
              <td>${item.state || ''}</td>
              <td>${item.total_booksellers || 0}</td>
              <td>${item.total_book_copies || 0}</td>
            </tr>
          `).join('')}

          <tr class="total-row">
            <td>एकूण</td>
            <td>${this.total_sub_count}</td>
            <td>${this.totalparcel}</td>
          </tr>

        </tbody>
      </table>

    </body>
    </html>
    `;

    win.document.write(html);
    win.document.close();
  }

  close(): void {
    this.dialogref.close();
  }
}